import type { LayerFieldDetail } from './layersApi';

/** Shared between LayerTable and the object card page — both render/edit the
 * same kind of per-field-type value, no reason for two copies to drift. */
export function formatCellValue(value: unknown): string {
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'boolean') return value ? 'да' : 'нет';
  if (typeof value === 'number') return value.toLocaleString('ru-RU');
  return String(value);
}

/** HTML input type/step per field data type — this is what stops most invalid
 * characters from being typed at all, not just what parses the result. */
export function inputPropsFor(dataType: LayerFieldDetail['data_type']): { type: string; step?: string } {
  switch (dataType) {
    case 'integer':
      return { type: 'number', step: '1' };
    case 'decimal':
      return { type: 'number', step: 'any' };
    case 'date':
      return { type: 'date' };
    case 'datetime':
      return { type: 'datetime-local' };
    default:
      return { type: 'text' };
  }
}

export type ParseResult = { ok: true; value: unknown } | { ok: false; error: string };

/** Belt-and-braces validation on top of the input type restriction — a number
 * input still lets "1e5" or an empty invalid state through in some browsers. */
export function parseEditedValue(raw: string, dataType: LayerFieldDetail['data_type']): ParseResult {
  const trimmed = raw.trim();
  if (trimmed === '') return { ok: true, value: null };

  if (dataType === 'integer') {
    if (!/^-?\d+$/.test(trimmed)) return { ok: false, error: 'Нужно целое число' };
    return { ok: true, value: Number(trimmed) };
  }
  if (dataType === 'decimal') {
    const n = Number(trimmed);
    if (Number.isNaN(n)) return { ok: false, error: 'Нужно число' };
    return { ok: true, value: n };
  }
  return { ok: true, value: raw };
}
